import React, { useRef } from 'react';
import Modal from '../shared/Modal';

const TenantNameConflictModal = ({ open, onClose, existingName, onRetry }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open) return null;

    const handleRetry = () => {
        onRetry();
        onClose();
    };

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                onClick={onClose}
                className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors font-medium"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                onClick={handleRetry}
                className="flex-1 px-4 py-2 bg-primary text-white dark:text-black rounded-lg hover:bg-primary-hover transition-colors font-medium"
            >
                Changer le nom
            </button>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Nom déjà utilisé"
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            <div className="space-y-4">
                <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
                    <p className="text-sm text-amber-800 dark:text-amber-200">
                        Une organisation nommée <span className="font-semibold">"{existingName}"</span> existe déjà.
                    </p>
                    <p className="text-sm text-amber-700 dark:text-amber-300 mt-2">
                        Veuillez choisir un nom différent pour votre organisation.
                    </p>
                </div>

                <div className="pt-2">
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                        Suggestions :
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-sm text-gray-700 dark:text-gray-300">
                        <li>Ajouter une date ou un numéro : <span className="font-mono text-primary">{existingName} 2024</span></li>
                        <li>Préciser le département : <span className="font-mono text-primary">{existingName} - IT</span></li>
                        <li>Ajouter votre nom : <span className="font-mono text-primary">{existingName} - Équipe</span></li>
                    </ul>
                </div>
            </div>
        </Modal>
    );
};

export default TenantNameConflictModal;
